import { Modal, Paper, Typography } from '@material-ui/core'

import { getDirection, getTranslate } from '../../../localization'
import { Entity, LogContent } from '../../../types/auditLogs'
import JsonViewer from '../ResultModal/JsonViewer'
import ChangedFieldsTable from './ChangedFieldsTable'
import EntitiesTable from './EntitiesTable'
import { parseAuditContent } from './parseAuditContent'
import useStyles from './styles/index.styles'

interface ContentModalProps {
  onClose: () => void
  entities: Entity[]
  logContent: LogContent
}

const ContentModal: React.FC<ContentModalProps> = ({
  onClose,
  entities,
  logContent
}) => {
  const classes = useStyles()
  const content = parseAuditContent(logContent.data)

  return (
    <Modal open dir={getDirection()} onClose={onClose}>
      <Paper className={classes.modalPaper}>
        {entities.length > 0 && <EntitiesTable entities={entities} />}
        {logContent.changedFields.length > 0 && (
          <ChangedFieldsTable data={logContent.changedFields} />
        )}
        <Typography className={classes.contentTitlesHeader} variant="h2">
          {getTranslate('Content Info')}
        </Typography>
        <div className={classes.contentInfoContainerWrapper}>
          <div
            className={[
              classes.contentInfoContainer,
              logContent.changedFields.length > 0 &&
                classes.contentInfoContainerWithChangedFields
            ].join(' ')}>
            {content.kind === 'value' ? (
              <JsonViewer jsonData={content.value} />
            ) : (
              <Typography variant="body1">
                {getTranslate(
                  content.kind === 'empty'
                    ? 'No additional content recorded'
                    : 'Audit content could not be displayed'
                )}
              </Typography>
            )}
            {logContent.entities && logContent.entities.length > 0 && (
              <EntitiesTable entities={logContent.entities} />
            )}
          </div>
        </div>
      </Paper>
    </Modal>
  )
}

export default ContentModal
